


const initUserState = {

}

export default function reducer(state = initUserState, action) {

  return state;
}